import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './components/Navbar';
import FooterSection from './components/FooterSection';

function StudentForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    // name: '',
    // email: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    organization: '',
    age: '',
    gender: '',
    year_of_mbbs: '',
    medium_of_schooling: '',
    medium_other: '',
    place_of_schooling: '',
    previous_exposure: '',
    prior_training: '',
    listening_improves_outcomes: '',
    patients_in_decisions: '',
    address_emotional_concerns: '',
    explain_simple_language: '',
    respectful_builds_trust: '',
    confident_initiating: '',
    explain_clearly: '',
    respond_empathetically: '',
    listen_without_interrupting: '',
    manage_difficult_calmly: '',
    anxiety_observed: '',
    stress_affects_communication: '',
    confidence_before_interaction: '',
    fear_reduces_effectiveness: '',
    comfortable_local_language: '',
    language_differences_challenging: '',
    cultural_beliefs_influence: '',
    skills_improve_training: '',
    open_to_feedback: '',
    comfortable_ai_feedback: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [countdown, setCountdown] = useState(15);
  const [organizations, setOrganizations] = useState([]);
  const [loadingOrganizations, setLoadingOrganizations] = useState(false);

  console.log("organizations", organizations)

  const API_BASE_URL = "https://testone.conversationaily.ai";

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      setLoadingOrganizations(true);

      const response = await axios.get(
        "https://testone.conversationaily.ai/api/organizations"
      );

      setOrganizations(response.data?.data || response.data || []);
    } catch (error) {
      console.error("Error fetching organizations:", error);
    } finally {
      setLoadingOrganizations(false);
    }
  };

  useEffect(() => {
    if (showSuccess && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }

    if (showSuccess && countdown === 0) {
      navigate("/");
    }
  }, [showSuccess, countdown, navigate]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!consentChecked) {
      alert('Please agree to the consent form to proceed');
      return { consent: 'Consent is required' };
    }

    // Basic Information
    if (!formData.first_name.trim()) newErrors.first_name = 'First name is required';
    if (!formData.last_name.trim()) newErrors.last_name = 'Last name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.age) newErrors.age = 'Age is required';
    else if (formData.age < 18 || formData.age > 100) newErrors.age = 'Age must be between 18 and 100';

    // Demographic fields
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!formData.year_of_mbbs) newErrors.year_of_mbbs = 'Year of MBBS is required';
    if (!formData.medium_of_schooling) newErrors.medium_of_schooling = 'Medium of schooling is required';
    if (formData.medium_of_schooling === 'Regional language' && !formData.medium_other.trim()) {
      newErrors.medium_other = 'Please specify the regional language';
    }
    if (!formData.place_of_schooling) newErrors.place_of_schooling = 'Place of schooling is required';
    if (!formData.previous_exposure) newErrors.previous_exposure = 'Previous exposure is required';
    if (!formData.prior_training) newErrors.prior_training = 'Prior training is required';

    // Attitude questions
    const attitudeFields = [
      'listening_improves_outcomes', 'patients_in_decisions', 'address_emotional_concerns',
      'explain_simple_language', 'respectful_builds_trust'
    ];
    attitudeFields.forEach(field => {
      if (!formData[field]) newErrors[field] = 'This field is required';
    });

    // Self-efficacy questions
    const efficacyFields = [
      'confident_initiating', 'explain_clearly', 'respond_empathetically',
      'listen_without_interrupting', 'manage_difficult_calmly'
    ];
    efficacyFields.forEach(field => {
      if (!formData[field]) newErrors[field] = 'This field is required';
    });

    // Stress & anxiety questions
    const stressFields = [
      'anxiety_observed', 'stress_affects_communication', 'confidence_before_interaction',
      'fear_reduces_effectiveness'
    ];
    stressFields.forEach(field => {
      if (!formData[field]) newErrors[field] = 'This field is required';
    });

    // Language & cultural questions
    const languageFields = [
      'comfortable_local_language', 'language_differences_challenging', 'cultural_beliefs_influence'
    ];
    languageFields.forEach(field => {
      if (!formData[field]) newErrors[field] = 'This field is required';
    });

    // Learning orientation questions
    const learningFields = [
      'skills_improve_training', 'open_to_feedback', 'comfortable_ai_feedback'
    ];
    learningFields.forEach(field => {
      if (!formData[field]) newErrors[field] = 'This field is required';
    });

    return newErrors;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const validationErrors = validateForm();
  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //     alert('Please fill in all required fields');
  //     return;
  //   }

  //   setIsSubmitting(true);

  //   try {
  //     // Prepare data for submission
  //     const submitData = { ...formData };

  //     // Handle medium of schooling
  //     if (formData.medium_of_schooling === 'Regional language') {
  //       submitData.medium_of_schooling = formData.medium_other;
  //     }
  //     delete submitData.medium_other;

  //     // Convert string values to integers for rating fields
  //     const ratingFields = [
  //       'listening_improves_outcomes', 'patients_in_decisions', 'address_emotional_concerns',
  //       'explain_simple_language', 'respectful_builds_trust', 'confident_initiating',
  //       'explain_clearly', 'respond_empathetically', 'listen_without_interrupting',
  //       'manage_difficult_calmly', 'anxiety_observed', 'stress_affects_communication',
  //       'confidence_before_interaction', 'fear_reduces_effectiveness', 'comfortable_local_language',
  //       'language_differences_challenging', 'cultural_beliefs_influence', 'skills_improve_training',
  //       'open_to_feedback', 'comfortable_ai_feedback'
  //     ];

  //     ratingFields.forEach(field => {
  //       submitData[field] = parseInt(submitData[field]);
  //     });
  //     submitData.age = parseInt(submitData.age);

  //     const response = await axios.post(`${API_BASE_URL}/api/pre-scenario/submit`, submitData);

  //     if (response.data.success) {
  //       // Store session ID in localStorage
  //       localStorage.setItem('sessionId', response.data.session_id);
  //       localStorage.setItem('studentName', formData.name);

  //       // Store access token if provided
  //       if (response.data.access_token) {
  //         localStorage.setItem('accessToken', response.data.access_token);
  //       }

  //       // Navigate to cases page
  //       {/* navigate('/cases', { replace: true }); */ }
  //       {/*  navigate("/login");  */ }
  //       setShowSuccess(true);
  //     }
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //     alert('Failed to submit form. Please try again.');
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };


const handleSubmit = async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const validationErrors = validateForm();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    alert("Please fill in all required fields");
    return;
  }

  setIsSubmitting(true);

  try {
    // Step 1: Register User
    const registerPayload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      password: formData.password,
      organization: formData.organization,
    };

    const registerResponse = await axios.post(
      `${API_BASE_URL}/api/users/register`,
      registerPayload
    );

    if (!registerResponse.data?.success) {
      throw new Error("User registration failed");
    }

    // Step 2: Existing Pre-Scenario Submission
    const submitData = { ...formData };

    if (formData.medium_of_schooling === "Regional language") {
      submitData.medium_of_schooling = formData.medium_other;
    }

    delete submitData.medium_other;
    delete submitData.password; // optional
    delete submitData.first_name; // optional
    delete submitData.last_name; // optional
    delete submitData.organization; // optional

    submitData.name = formData.first_name + " " + formData.last_name;

    const ratingFields = [
      "listening_improves_outcomes",
      "patients_in_decisions",
      "address_emotional_concerns",
      "explain_simple_language",
      "respectful_builds_trust",
      "confident_initiating",
      "explain_clearly",
      "respond_empathetically",
      "listen_without_interrupting",
      "manage_difficult_calmly",
      "anxiety_observed",
      "stress_affects_communication",
      "confidence_before_interaction",
      "fear_reduces_effectiveness",
      "comfortable_local_language",
      "language_differences_challenging",
      "cultural_beliefs_influence",
      "skills_improve_training",
      "open_to_feedback",
      "comfortable_ai_feedback",
    ];

    ratingFields.forEach((field) => {
      submitData[field] = parseInt(submitData[field]);
    });

    submitData.age = parseInt(submitData.age);

    const response = await axios.post(
      `${API_BASE_URL}/api/pre-scenario/submit`,
      submitData
    );

    if (response.data.success) {
      localStorage.setItem("sessionId", response.data.session_id);

      localStorage.setItem(
        "studentName",
        `${formData.first_name} ${formData.last_name}`
      );

      if (response.data.access_token) {
        localStorage.setItem(
          "accessToken",
          response.data.access_token
        );
      }

      setShowSuccess(true);
    }
  } catch (error) {
    console.error("Error:", error);

    alert(
      error?.response?.data?.message ||
        "Failed to submit form. Please try again."
    );
  } finally {
    setIsSubmitting(false);
  }
};

  const ScaleOptions = () => (
    <>
      <option value="">Select</option>
      <option value="1">1 - Strongly Disagree</option>
      <option value="2">2 - Disagree</option>
      <option value="3">3 - Neutral</option>
      <option value="4">4 - Agree</option>
      <option value="5">5 - Strongly Agree</option>
    </>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="py-8 px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          {showSuccess && (
            <div className="bg-green-50 border border-green-300 text-green-800 p-6 rounded-lg mb-6 text-center">
              <h2 className="text-xl font-semibold mb-2">Registration Successful</h2>
              <p className="mb-2">
                {/* Thank you for sharing your details. The login credentials for the test will be shared with you shortly via email, along with the instructions to complete it. */}
                  Thank you for registering. Your username and password will be sent to your registered email ID in 24 hours.
             
              </p>
              <p className="font-medium">
                Redirecting to login in {countdown} seconds...
              </p>
            </div>
          )}
          <div className="mb-8 text-center">
            {/* <h1 className="text-3xl font-semibold text-[#1D3A73] mb-3">Evaluation: Institute of Medical Sciences SUM</h1> */}
            <h1 className="text-xl font-bold text-[#1D3A73] mb-4"> Assessment of AETCOM-Based Doctor–Patient Communication Skills among MBBS Undergraduate Students Using Scenario-Based Simulated Consultations and AI-Assisted Feedback: A Cross-Sectional Study </h1>
            <p className="text-gray-600">Please complete this form before starting the mock consultation</p>
          </div>

          {!showSuccess && (
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Consent Section */}
              <section className="bg-blue-50 p-6 rounded-lg border-2 border-[#1D3A73]">
                <h2 className="text-xl font-semibold text-[#1D3A73] mb-4">About This Activity</h2>
                <div className="text-sm text-gray-700 space-y-3 mb-4">
                  <p>You are invited by Sikkim Manipal Institute of Medical Sciences to participate in a research study assessing AETCOM-based doctor–patient communication skills among MBBS undergraduate students using scenario-based simulated consultations and AI-assisted feedback. Participation involves completing three standardized, audio-only simulated consultation scenarios reflecting common clinical and community communication contexts. No real patients are involved. Your responses will be recorded and processed using an AI-enabled communication analysis platform to evaluate domains such as empathy, clarity, professionalism, and patient-centered language.</p>
                  <p>Participation is entirely voluntary. There are no academic rewards or penalties associated with participation or non-participation. All recordings will be anonymized prior to analysis, and confidentiality will be strictly maintained. Data will be used solely for research and academic improvement purposes. You may withdraw from the study at any time before or during participation without providing a reason and without any academic consequences.</p>
                  <p>By providing consent, you acknowledge that you have understood the study procedures and agree to participate voluntarily.</p>
                </div>
                <div className="flex items-start">
                  <input
                    type="checkbox"
                    id="consent"
                    checked={consentChecked}
                    onChange={(e) => setConsentChecked(e.target.checked)}
                    className="mt-1 mr-3 h-4 w-4 text-[#1D3A73] focus:ring-[#1D3A73] border-gray-300 rounded"
                  />
                  <label htmlFor="consent" className="text-sm font-medium text-gray-700">
                    I agree <span className="text-red-500">*</span>
                  </label>
                </div>
              </section>
              {/* Basic Information */}
              <section>
                <h2 className="text-xl font-semibold text-[#1D3A73] mb-4 border-b-2 border-[#FFA500] pb-2">Basic Information</h2>
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`w-full px-3 py-2 border rounded-md ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`w-full px-3 py-2 border rounded-md ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
              </div>
            </div> */}


                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* First Name */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.first_name ? "border-red-500" : "border-gray-300"
                        }`}
                    />
                    {errors.first_name && (
                      <p className="text-red-500 text-xs mt-1">{errors.first_name}</p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.last_name ? "border-red-500" : "border-gray-300"
                        }`}
                    />
                    {errors.last_name && (
                      <p className="text-red-500 text-xs mt-1">{errors.last_name}</p>
                    )}
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.email ? "border-red-500" : "border-gray-300"
                        }`}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                    )}
                  </div>

                  {/* Password */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.password ? "border-red-500" : "border-gray-300"
                        }`}
                    />
                    {errors.password && (
                      <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                    )}
                  </div>

                  {/* Organization */}
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Organization <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.organization ? "border-red-500" : "border-gray-300"
                        }`}
                    >
                      <option value="">Select Organization</option>
                      {(organizations.organizations || []).map((org) => (
                        <option key={org.id} value={org.code}>
                          {org.name}
                        </option>
                      ))}
                    </select>
                    {errors.organization && (
                      <p className="text-red-500 text-xs mt-1">{errors.organization}</p>
                    )}
                  </div>
                </div>
              </section>

              {/* Section A: Demographic & Educational Context */}
              <section>
                <h2 className="text-xl font-semibold text-[#1D3A73] mb-4 border-b-2 border-[#FFA500] pb-2">
                  SECTION A: Demographic & Educational Context
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Age (years) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.age ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.age && <p className="text-red-500 text-xs mt-1">{errors.age}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Gender <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.gender ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.gender && <p className="text-red-500 text-xs mt-1">{errors.gender}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Year of MBBS <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="year_of_mbbs"
                      value={formData.year_of_mbbs}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.year_of_mbbs ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd Part I">3rd Part I</option>
                      <option value="Final">Final</option>
                      <option value="Intern">Intern</option>
                    </select>
                    {errors.year_of_mbbs && <p className="text-red-500 text-xs mt-1">{errors.year_of_mbbs}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Medium of schooling before MBBS <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="medium_of_schooling"
                      value={formData.medium_of_schooling}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.medium_of_schooling ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="English">English</option>
                      <option value="Regional language">Regional language</option>
                    </select>
                    {errors.medium_of_schooling && <p className="text-red-500 text-xs mt-1">{errors.medium_of_schooling}</p>}
                  </div>

                  {formData.medium_of_schooling === 'Regional language' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Specify Regional Language <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="medium_other"
                        value={formData.medium_other}
                        onChange={handleChange}
                        placeholder="e.g., Hindi, Tamil, etc."
                        className={`w-full px-3 py-2 border rounded-md ${errors.medium_other ? 'border-red-500' : 'border-gray-300'}`}
                      />
                      {errors.medium_other && <p className="text-red-500 text-xs mt-1">{errors.medium_other}</p>}
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Place of schooling <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="place_of_schooling"
                      value={formData.place_of_schooling}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.place_of_schooling ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="Urban">Urban</option>
                      <option value="Semi-urban">Semi-urban</option>
                      <option value="Rural">Rural</option>
                    </select>
                    {errors.place_of_schooling && <p className="text-red-500 text-xs mt-1">{errors.place_of_schooling}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Previous exposure to patient interaction <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="previous_exposure"
                      value={formData.previous_exposure}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.previous_exposure ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="None">None</option>
                      <option value="Occasional">Occasional</option>
                      <option value="Regular">Regular</option>
                    </select>
                    {errors.previous_exposure && <p className="text-red-500 text-xs mt-1">{errors.previous_exposure}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Prior formal communication skills training <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="prior_training"
                      value={formData.prior_training}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border rounded-md ${errors.prior_training ? 'border-red-500' : 'border-gray-300'}`}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    {errors.prior_training && <p className="text-red-500 text-xs mt-1">{errors.prior_training}</p>}
                  </div>
                </div>
              </section>

              {/* Section B: Determinants */}
              <section>
                <h2 className="text-xl font-semibold text-[#1D3A73] mb-4 border-b-2 border-[#FFA500] pb-2">
                  SECTION B: Determinants of Doctor–Patient Communication
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  Response Scale: 1 = Strongly Disagree, 2 = Disagree, 3 = Neutral, 4 = Agree, 5 = Strongly Agree
                </p>

                {/* Attitude Towards Patient-Centered Communication */}
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-[#1D3A73] mb-3">Attitude Towards Patient-Centered Communication</h3>
                  <div className="space-y-3">
                    {[
                      { name: 'listening_improves_outcomes', label: 'Listening to patients improves clinical outcomes' },
                      { name: 'patients_in_decisions', label: 'Patients should be involved in treatment decisions' },
                      { name: 'address_emotional_concerns', label: 'A doctor should address emotional concerns' },
                      { name: 'explain_simple_language', label: 'Explaining illness in simple language is a doctor\'s duty' },
                      { name: 'respectful_builds_trust', label: 'Respectful communication builds patient trust' }
                    ].map(field => (
                      <div key={field.name}>
                        <label className="block text-sm text-gray-700 mb-1">
                          {field.label} <span className="text-red-500">*</span>
                        </label>
                        <select
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          className={`w-full px-3 py-2 border rounded-md ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                        >
                          <ScaleOptions />
                        </select>
                        {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Communication Self-Efficacy */}
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-[#1D3A73] mb-3">Communication Self-Efficacy</h3>
                  <div className="space-y-3">
                    {[
                      { name: 'confident_initiating', label: 'Confident initiating conversation with patients' },
                      { name: 'explain_clearly', label: 'Can explain medical problems clearly' },
                      { name: 'respond_empathetically', label: 'Can respond empathetically' },
                      { name: 'listen_without_interrupting', label: 'Can listen without interrupting' },
                      { name: 'manage_difficult_calmly', label: 'Can manage difficult interactions calmly' }
                    ].map(field => (
                      <div key={field.name}>
                        <label className="block text-sm text-gray-700 mb-1">
                          {field.label} <span className="text-red-500">*</span>
                        </label>
                        <select
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          className={`w-full px-3 py-2 border rounded-md ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                        >
                          <ScaleOptions />
                        </select>
                        {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Stress & Evaluation Anxiety */}
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-[#1D3A73] mb-3">Stress & Evaluation Anxiety</h3>
                  <div className="space-y-3">
                    {[
                      { name: 'anxiety_observed', label: 'Anxiety about being observed or recorded' },
                      { name: 'stress_affects_communication', label: 'Stress affects communication' },
                      { name: 'confidence_before_interaction', label: 'Confidence before interaction (reverse scored)' },
                      { name: 'fear_reduces_effectiveness', label: 'Fear of mistakes reduces effectiveness' }
                    ].map(field => (
                      <div key={field.name}>
                        <label className="block text-sm text-gray-700 mb-1">
                          {field.label} <span className="text-red-500">*</span>
                        </label>
                        <select
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          className={`w-full px-3 py-2 border rounded-md ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                        >
                          <ScaleOptions />
                        </select>
                        {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Language & Cultural Comfort */}
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-[#1D3A73] mb-3">Language & Cultural Comfort</h3>
                  <div className="space-y-3">
                    {[
                      { name: 'comfortable_local_language', label: 'Comfortable communicating in local language' },
                      { name: 'language_differences_challenging', label: 'Language/literacy differences are challenging' },
                      { name: 'cultural_beliefs_influence', label: 'Cultural beliefs influence communication' }
                    ].map(field => (
                      <div key={field.name}>
                        <label className="block text-sm text-gray-700 mb-1">
                          {field.label} <span className="text-red-500">*</span>
                        </label>
                        <select
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          className={`w-full px-3 py-2 border rounded-md ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                        >
                          <ScaleOptions />
                        </select>
                        {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Learning Orientation & Feedback Acceptance */}
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-[#1D3A73] mb-3">Learning Orientation & Feedback Acceptance</h3>
                  <div className="space-y-3">
                    {[
                      { name: 'skills_improve_training', label: 'Communication skills improve with training' },
                      { name: 'open_to_feedback', label: 'Open to feedback' },
                      { name: 'comfortable_ai_feedback', label: 'Comfortable with AI-based consultation feedback' }
                    ].map(field => (
                      <div key={field.name}>
                        <label className="block text-sm text-gray-700 mb-1">
                          {field.label} <span className="text-red-500">*</span>
                        </label>
                        <select
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          className={`w-full px-3 py-2 border rounded-md ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                        >
                          <ScaleOptions />
                        </select>
                        {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              </section>

              {/* Submit Button */}
              <div className="flex justify-end space-x-4 pt-6 border-t">
                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting || !consentChecked}
                  className="px-6 py-2 bg-[#1D3A73] text-white rounded-md hover:bg-[#FFA500] disabled:bg-gray-400 transition-colors"
                >
                  {isSubmitting ? 'Registering...' : 'Register'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default StudentForm;
